import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectList from './project_list';
import ProjectDetail from './project_detail';

class Project extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <ProjectList/>;
    }else{
      if(params.id===undefined){
        view = <ProjectDetail/>;
      }else{
        view = <ProjectDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Project.contextTypes = {
  router: PropTypes.object
};

export default Project;
